import {Component, OnDestroy, OnInit} from '@angular/core';
import { FrontDeskInstructionsService } from 'app/services/front-desk-instructions.service';
import { UrlService } from 'app/services/url.service';
declare const moment: any;
@Component({
    selector: 'front-desk-instructions',
    templateUrl: './front-desk-instructions.component.html',
})
export class FrontDeskInstructionsComponent implements OnInit, OnDestroy {
    data: any;
    total: number;
    loading: boolean;
    constructor(
        public frontDeskInstructionsService: FrontDeskInstructionsService,
        public urlService: UrlService
    ) { }

    ngOnInit(): void {
        this.frontDeskInstructionsService.showSpinner = true;
        this.urlService.setQueryParams('allInstructions');
        this.urlService.onUrlChange.subscribe(() => {
            this.frontDeskInstructionsService.isEditInstruction = false;
            this.frontDeskInstructionsService.getInstructions();
        });
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.frontDeskInstructionsService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/front-desk-instructions/front-desk-instructions.component.ts